import { toBlob } from "html-to-image";

const EMAIL = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi;
const PHONE = /(\+?1[\s.-]?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}/g;
const CARD = /\b(?:\d[ -]?){13,16}\b/g;
const VIN = /\b[A-HJ-NPR-Z0-9]{17}\b/g;
const scrub = (t) => t.replace(EMAIL, "demo@example.com").replace(CARD, "•••• •••• •••• 4242").replace(VIN, "1HGCM82633A000000").replace(PHONE, "(555) 010-0000");

export const maskDoc = (doc) => {
  const undo = [];
  const w = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);
  for (let n = w.nextNode(); n; n = w.nextNode()) { const s = scrub(n.nodeValue); if (s !== n.nodeValue) { const o = n.nodeValue; const node = n; undo.push(() => { node.nodeValue = o; }); n.nodeValue = s; } }
  doc.querySelectorAll("input, textarea").forEach(el => {
    const o = el.value, sens = /password|email|tel|card|cvc|ssn/i.test(`${el.type} ${el.name} ${el.autocomplete}`);
    const s = sens ? (el.type === "password" ? "••••••••" : scrub(o) === o && o ? "demo" : scrub(o)) : scrub(o);
    if (s !== o) { el.value = s; undo.push(() => { el.value = o; }); }
  });
  doc.querySelectorAll("[data-sensitive]").forEach(el => { const o = el.style.filter; el.style.filter = "blur(6px)"; undo.push(() => { el.style.filter = o; }); });
  return () => undo.forEach(f => f());
};

const skip = (n) => !(n.dataset && n.dataset.noCapture !== undefined);

export const captureCurrent = async () => {
  const restore = maskDoc(document);
  try {
    return await toBlob(document.body, { width: window.innerWidth, height: window.innerHeight, pixelRatio: 1, filter: skip, cacheBust: true,
      style: { transform: `translate(${-window.scrollX}px, ${-window.scrollY}px)` }, backgroundColor: "#ffffff" });
  } finally { restore(); }
};

export const VIEWPORTS = { desktop: [1440, 900], tablet: [820, 1180], mobile: [390, 844] };

export const captureRoute = (route, viewport) => new Promise((resolve, reject) => {
  const [w, h] = VIEWPORTS[viewport];
  const f = document.createElement("iframe");
  Object.assign(f.style, { position: "fixed", left: "-10000px", top: "0", width: `${w}px`, height: `${h}px`, border: "0" });
  f.src = route;
  const done = (fn) => { setTimeout(() => f.remove(), 50); fn(); };
  f.onload = () => setTimeout(async () => {
    try {
      const d = f.contentDocument;
      d.querySelectorAll("[data-no-capture]").forEach(el => el.remove());
      maskDoc(d);
      const blob = await toBlob(d.body, { width: w, height: h, pixelRatio: 1, cacheBust: true, backgroundColor: "#ffffff" });
      done(() => resolve(blob));
    } catch (e) { done(() => reject(e)); }
  }, 3500);
  document.body.appendChild(f);
});
